import { render, staticRenderFns } from "./SupplierManufacturingTransport.vue?vue&type=template&id=64d6393a&scoped=true&"
import script from "./SupplierManufacturingTransport.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6393a",
  null
  
)

export default component.exports